/**
 * useReportRitual Hook
 * Mutation hook for submitting ritual reports
 */

import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { toast } from "sonner"
import { createRitualReport } from "@/services/report.service"

export function useReportRitual() {
  return useMutation({
    mutationFn: createRitualReport,
    onError: (error: unknown) => {
      let message = "Failed to submit report"
      if (axios.isAxiosError(error)) {
        message = error.response?.data?.message || error.message
      } else if (error instanceof Error) {
        message = error.message
      }
      toast.error(message)
    },
  })
}
